module.exports = __webpack_public_path__ + "static/media/web02_jpn.f838770f.png";